import reducer from './reducer'

export { moduleName } from './constants'
export { useWindowActions } from './hook'
export * as windowSelectors from './selectors'

export default reducer
